import React, {useEffect, useRef, useState} from 'react';
import './index.css';
import TabSection from '../../components/tabsection/index';
import {Trans, useTranslation} from 'react-i18next';
import {Form, Field, Formik} from 'formik';
import _get from 'lodash/get';
import TextareaBox from '../../../../components/formik/TextareaBox';
import ToggleEnableField from '../../components/togglernablefield';
import skinDetectionCategories from '../../../../utils/config/skinDetectionCategories';
import CustomSwitch from '../../../../components/layout/CustomSwitch';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import Header from '../../components/header';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import SkincareDetectionPreview from './preview';
import {
  detectionType,
  getTemplate,
  getDetectionLanguages,
  getBrandId,
  getTemplateDefaultConfig,
  mappingDisable,
  arrayMapping,
  updateTemplate,
  descriptionContent,
  getDisabledDetectionCategoriesByPlan,
  disabledSkinType,
  disabledSkinSensitivity,
} from '../../../../utils/skincareUtils';
import Loader from '../../../../components/spinner/Loader';
import Select from 'react-select';
import config from '../config/utils/contentUtils';
import SelectBox from '../../../../components/formik/SelectBox';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import NewFeatureNote from '../../../../components/newfeaturenote';
import smbUtils from '../../../../utils/smbUtils';
import useSolutionType from '../../../../components/hook/useSolutionType';
import useSkincare from '../../../../components/hook/useSkincare';
import Section from '../layout/Section';
import LeftTitleWithField from '../layout/LeftTitleWithField';
import _isUndefined from 'lodash/isUndefined';
import InputBox from '../../../../components/formik/InputBox';
import langUtils from '../../../../utils/langUtils';
import ProcessingInProgressModal from '../components/ProcessingInProgressModal';
import { isFunctionBusyError } from '../../../../utils/errorUtils';

export default function SkincareDetection() {
  const [initValue, setInitValue] = useState({});
  const {t} = useTranslation();
  const formRef = useRef();
  const [commonData, setCommonData] = useState({});
  const [templateType, setTemplateType] = useState('SkincareDetection');
  const [templateId, setTemplateId] = useState('');
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [isShowProcessingModal, setIsShowProcessingModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);

  const auth = useSelector(state => state.components.auth.accountSummary);
  const {token, customerId} = smbUtils.customerInfo(auth);
  const {isSkinAnalysisPremium: isPremiumPlan} = useSolutionType(auth);
  const {
    isEnterprise,
    isV1,
    isV2Above,
    isVersionAbove2AndHd,
    isSupportSubOptions,
    isSupportSkinType,
    isSupportSensitivity,
  } = useSkincare(auth);

  let displayCategories = [];
  let displayRecommendCategory = [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const brandRes = await getBrandId(token, customerId);
        const revId = _get(brandRes, 'skincareDetectionRvId', '');
        if (!revId) return;

        isV2Above &&
          _get(brandRes, 'commonSettingRvId') &&
          (await getTemplate(
            token,
            customerId,
            _get(brandRes, 'commonSettingRvId'),
            'CommonSetting'
          ).then(res => {
            if (res && res.configJson) {
              setCommonData(JSON.parse(res.configJson));
            }
          }));

        await getTemplate(token, customerId, revId).then(res => {
          if (res && res.metaDataJson) {
            setInitValue(JSON.parse(_get(res, 'metaDataJson', '')));
          }
          setTemplateId(_get(res, 'templateId', ''));
          setTemplateType(_get(res, 'templateType', ''));
          setIsLoaded(false);
        });
      } catch (error) {
        console.error('Error fetching skincare detection data:', error);
      }
    };

    fetchData();
  }, []);

  const handleRestore = mode => {
    getTemplateDefaultConfig('SmbSkincareDetection ', mode, 2, customerId).then(
      r => {
        if (r && r.templateMetadata) {
          let data = r.templateMetadata;
          setInitValue({
            ...data,
            recommendCategory:
              _get(data, 'recommendCategory', []).length > 0
                ? _get(data, 'recommendCategory', [])
                : ['productRecommend'],
          });
          updateTemplate(
            token,
            customerId,
            templateId,
            templateType,
            data
          ).then(r => {
            setPublishStatus(!publishStatus);
            toast.success(
              <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
            );
          });
        }
      }
    );
  };

  const getInitValue = values => {
    const v = values || {};

    const sequenceOfCategory = mappingDisable(
      _get(v, 'sequenceOfCategory', []),
      skinDetectionCategories.getSkinDetectionCategories4MultipleVersion(
        isVersionAbove2AndHd
      ),
      isSupportSubOptions
    );

    displayCategories =
      sequenceOfCategory.length > 0
        ? sequenceOfCategory.filter(v => v.value !== 'dark_circle')
        : [];

    const sequenceOfRecommendCategory = mappingDisable(
      _get(v, 'recommendCategory', []),
      skinDetectionCategories.getSkinRecommendCategory()
    );
    displayRecommendCategory =
      sequenceOfRecommendCategory.length > 0 ? sequenceOfRecommendCategory : [];

    return {
      isHideSkinAge: _get(v, 'isHideSkinAge'),
      isShowSkinAge: !_get(v, 'isHideSkinAge'),
      isShowSkinHealth: _get(v, 'isShowSkinHealth'),
      isShowSkinType: _get(v, 'isShowSkinType', false),
      sequenceOfCategory: sequenceOfCategory,
      recommendCategory: sequenceOfRecommendCategory,
      skincareRecommendMode: _get(v, 'skincareRecommendMode', 'none'),
      detectionDescriptionContent: _get(
        v,
        'detectionDescriptionContent[zh-Hans]'
      )
        ? config.updateDefaultContent(
            _get(v, 'detectionDescriptionContent'),
            config.detectionDescriptionContentVersion(isVersionAbove2AndHd),
            isSupportSkinType && _isUndefined(_get(v, 'isShowSkinType'))
          )
        : {
            ...config.detectionDescriptionContentVersion(isVersionAbove2AndHd),
            language: 'en',
          },
      buttonText: _get(v, 'buttonText')
        ? _get(v, 'buttonText')
        : {
            viewSkinReport: {
              ...config.buttonText.viewSkinReport,
              language: 'en',
            },
          },
    };
  };

  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true);

      let newCategoryData = arrayMapping(
        values.sequenceOfCategory,
        isSupportSubOptions
      );
      let newRecommendCategoryData = arrayMapping(values.recommendCategory);

      const data = {
        isHideSkinAge: !values.isShowSkinAge,
        sequenceOfCategory: newCategoryData,
        recommendCategory:
          values.skincareRecommendMode === 'recommendation'
            ? newRecommendCategoryData
            : [],
        skincareRecommendMode: values.skincareRecommendMode,
        isShowSkinHealth: values.isShowSkinHealth,
        isShowSkinType: values.isShowSkinType,
        detectionDescriptionContent: values.detectionDescriptionContent,
        buttonText: values.buttonText,
      };

      if (
        data.skincareRecommendMode === 'recommendation' &&
        data.recommendCategory.length === 0
      ) {
        toast.error(
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.recommendCategory.null">
            Please enable at least one category in "Product Recommendation
            Category".
          </Trans>
        );
        setSubmitting(false);
        return;
      }

      await updateTemplate(token, customerId, templateId, templateType, data)
        .then(r => {
          setInitValue({
            ...data,
            recommendCategory: newRecommendCategoryData,
          });
          setIsShowPublishModal(true);
        })
        .catch(e => {
          if (isFunctionBusyError(e)) {
            setIsShowProcessingModal(true);
            setSubmitting(false);
            return;
          }

          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form className="skincare-configuration-form">
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div
            className="skincare-configuration-layout"
            style={{height: isV1 && 'calc(100% - 170px)'}}
          >
            <div className="skincare-configuration-layout__left">
              {isV1 && <TabSection dirty={formikProps.dirty} />}
              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <div>
                    <Section
                      title={
                        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.skin.age">
                          Skin Age
                        </Trans>
                      }
                    >
                      <LeftTitleWithField
                        title={
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.show">
                            Show
                          </Trans>
                        }
                      >
                        <Field
                          name="isShowSkinAge"
                          value={_get(formikProps.values, 'isShowSkinAge')}
                          component={CustomSwitch}
                        />
                      </LeftTitleWithField>
                    </Section>
                    {isSupportSkinType && (
                      <Section
                        title={
                          <div className="d-flex align-items-center">
                            <Trans i18nKey="p.s.uiconfiguration.skincaredetection.skin.type">
                              Skin Type
                            </Trans>
                            <div>
                              {smbUtils.isShowNewLabelForOldVersion() && (
                                <div className="pf-smb-menu__new-feature__icon" />
                              )}
                            </div>
                          </div>
                        }
                      >
                        <LeftTitleWithField
                          title={
                            <Trans i18nKey="p.s.uiconfiguration.skincaredetection.show">
                              Show
                            </Trans>
                          }
                        >
                          <Field
                            name="isShowSkinType"
                            value={_get(formikProps.values, 'isShowSkinType')}
                            component={CustomSwitch}
                          />
                        </LeftTitleWithField>
                      </Section>
                    )}
                    <Section
                      title={
                        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.skin.health">
                          Skin Health
                        </Trans>
                      }
                    >
                      <LeftTitleWithField
                        title={
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.show">
                            Show
                          </Trans>
                        }
                      >
                        <Field
                          name="isShowSkinHealth"
                          value={_get(formikProps.values, 'isShowSkinHealth')}
                          component={CustomSwitch}
                        />
                      </LeftTitleWithField>
                    </Section>
                  </div>
                  {!isEnterprise &&
                    smbUtils.isShowNewLabel(auth, 14) &&
                    isSupportSubOptions && (
                      <div className="kt-margin-t-20">
                        <NewFeatureNote>
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.note">
                            <strong>Tear Trough</strong> and the detailed{' '}
                            <strong>facial areas for Wrinkles and Pore</strong>{' '}
                            are now available for selection. Enable them below
                            and try out the new detection results!
                          </Trans>
                        </NewFeatureNote>
                      </div>
                    )}
                  <Section
                    title={
                      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category">
                        Skin Concern Detections
                      </Trans>
                    }
                  >
                    <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.desc">
                      Enable at least 3 skin concern options and sort orders for
                      them.
                    </Trans>
                    <Field name="sequenceOfCategory">
                      {props => (
                        <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                          <div className="col-md-12">
                            <ToggleEnableField
                              itemList={displayCategories}
                              onChange={list => {
                                const darkCircleIdx = list.findIndex(
                                  i => i.value === 'dark_circle'
                                );
                                const seqList = [...list];
                                if (darkCircleIdx !== -1) {
                                  seqList.splice(darkCircleIdx, 1);
                                }
                                props.form.setFieldValue(
                                  props.field.name,
                                  seqList
                                );
                              }}
                              minEnable={3}
                              disableItems={getDisabledDetectionCategoriesByPlan(
                                auth
                              )}
                              isEnterprise={isEnterprise}
                              isSupportSubOptions={isSupportSubOptions}
                              type={'SKIN_ANALYSIS'}
                            />
                          </div>
                        </div>
                      )}
                    </Field>
                  </Section>
                  {!isEnterprise &&
                    smbUtils.isShowNewLabel(auth, 14) &&
                    isSupportSubOptions && (
                      <div className="kt-margin-t-20">
                        <NewFeatureNote>
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.result.note">
                            You can now customize detection descriptions for the
                            new <strong>Tear Trough</strong> and the detailed{' '}
                            <strong>facial areas for Wrinkles and Pore</strong>{' '}
                            Scroll down to see more.
                          </Trans>
                        </NewFeatureNote>
                      </div>
                    )}
                  {isVersionAbove2AndHd && (
                    <Section
                      title={
                        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.button">
                          Button
                        </Trans>
                      }
                    >
                      <LeftTitleWithField
                        title={
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.button.view.report">
                            "View Report" Button Text
                          </Trans>
                        }
                      >
                        <div className="d-flex flex-row">
                          <Select
                            className="kt-margin-r-10"
                            options={getDetectionLanguages()}
                            onChange={o => {
                              formikProps.setFieldValue(
                                'buttonText.viewSkinReport.language',
                                o.value
                              );
                            }}
                            value={
                              getDetectionLanguages().find(
                                lang =>
                                  lang.value ===
                                  _get(
                                    formikProps.values,
                                    'buttonText.viewSkinReport.language',
                                    'en'
                                  )
                              ) || getDetectionLanguages()[0]
                            }
                            isSearchable={false}
                            isClearable={false}
                            placeholder={
                              <Trans i18nKey="c.c.select.placeholder">
                                Select...
                              </Trans>
                            }
                            styles={{
                              control: base => ({
                                ...base,
                                height: '45px',
                              }),
                            }}
                          />

                          <Field
                            name={`buttonText.viewSkinReport.${_get(
                              formikProps.values,
                              'buttonText.viewSkinReport.language',
                              'en'
                            )}`}
                            maxLength={langUtils.getAdjustedMaxLength(
                              30,
                              _get(
                                formikProps.values,
                                'buttonText.viewSkinReport.language',
                                'en'
                              )
                            )}
                            component={InputBox}
                            style={{height: '45px'}}
                          />
                        </div>
                      </LeftTitleWithField>
                    </Section>
                  )}
                  <Section
                    title={
                      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.skin.detection.result">
                        Skin Detection Result
                      </Trans>
                    }
                  >
                    <LeftTitleWithField
                      title={
                        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description">
                          Detection type
                        </Trans>
                      }
                    >
                      <Field
                        name="skincareRecommendMode"
                        component={SelectBox}
                        options={detectionType}
                        onChange={v => {
                          if (v === 'recommendation') {
                            const defaultCat = [
                              {
                                disabled: true,
                                value: 'routineRecommend',
                                label: 'Routines',
                              },
                              {
                                disabled: false,
                                value: 'productRecommend',
                                label: 'Products',
                              },
                              {
                                disabled: true,
                                value: 'treatmentRecommend',
                                label: 'Treatment',
                              },
                            ];
                            displayRecommendCategory = defaultCat;
                            formikProps.setFieldValue(
                              'recommendCategory',
                              defaultCat
                            );
                          }
                        }}
                      />
                    </LeftTitleWithField>
                  </Section>
                  {_get(formikProps.values, 'skincareRecommendMode') ===
                    'recommendation' && (
                    <div className="form-group">
                      <label className="col-form-label text-left">
                        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.produvt.recommendation.category">
                          Product Recommendation Category
                        </Trans>
                        <br />
                        <div
                          className="d-inline-block kt-margin-t-15"
                          style={{color: '#6c757d', fontSize: '13px'}}
                        >
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.produvt.recommendation.category.desc">
                            Used to enable or disable the functionalities of
                            product recommdation category and set order of the
                            enabling categories.
                          </Trans>
                        </div>
                      </label>
                      <Field name="recommendCategory">
                        {props => (
                          <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                            <div className="col-md-12">
                              <ToggleEnableField
                                itemList={props.field.value}
                                onChange={list => {
                                  const seqList = [...list];
                                  displayRecommendCategory = seqList;
                                  props.form.setFieldValue(
                                    props.field.name,
                                    seqList
                                  );
                                }}
                                minEnable={1}
                                type={'SKIN_ANALYSIS'}
                              />
                            </div>
                          </div>
                        )}
                      </Field>
                    </div>
                  )}
                  {_get(formikProps.values, 'skincareRecommendMode') ===
                    'description' && (
                    <>
                      <LeftTitleWithField
                        title={
                          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content">
                            Detection description content
                          </Trans>
                        }
                      >
                        <Select
                          options={getDetectionLanguages()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'detectionDescriptionContent.language',
                              o.value
                            );
                          }}
                          value={
                            getDetectionLanguages().find(
                              lang =>
                                lang.value ===
                                _get(
                                  formikProps.values,
                                  'detectionDescriptionContent.language',
                                  'en'
                                )
                            ) || getDetectionLanguages()[0]
                          }
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </LeftTitleWithField>
                      {descriptionContent(
                        {
                          ...getDetectionLanguages().find(
                            lang =>
                              lang.value ===
                              _get(
                                formikProps.values,
                                'detectionDescriptionContent.language',
                                'en'
                              )
                          ),
                        },
                        isVersionAbove2AndHd,
                        isPremiumPlan || isEnterprise
                      )
                        .filter(
                          item =>
                            !getDisabledDetectionCategoriesByPlan(
                              auth
                            ).includes(item.value)
                        )
                        .filter(item => {
                          const isInDisabledSkinType =
                            !isSupportSkinType &&
                            disabledSkinType.includes(item.value);
                          const isInDisabledSkinSensitivity =
                            !isSupportSensitivity &&
                            disabledSkinSensitivity.includes(item.value);
                          return (
                            !isInDisabledSkinType &&
                            !isInDisabledSkinSensitivity
                          );
                        })
                        .map(c => (
                          <LeftTitleWithField title={c.label}>
                            <Field
                              name={c.key}
                              component={TextareaBox}
                              placeholder={t('c.f.text.up.character', {
                                defaultValue:
                                  'Up to {{maxNum}} characters recommended.',
                                maxNum: 450,
                              })}
                            />
                          </LeftTitleWithField>
                        ))}
                    </>
                  )}
                </div>
                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(isPremiumPlan ? 'Premium' : 'Essential');
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && (
              <div className="skincare-configuration-layout__right">
                {formikProps.values &&
                  _get(formikProps.values, 'sequenceOfCategory') && (
                    <SkincareDetectionPreview
                      config={formikProps.values}
                      commonData={commonData}
                      isV2Above={isV2Above}
                      isHd={isVersionAbove2AndHd}
                      isSupportSubOptions={isSupportSubOptions}
                    />
                  )}
              </div>
            )}
          </div>
          <PublishToOnlineModal
            isShow={isShowPublishModal}
            onPublish={isPublish => {
              formikProps.setSubmitting(false);
              setPublishStatus(isPublish);
              setIsShowPublishModal(false);
            }}
          />
          <ProcessingInProgressModal
            show={isShowProcessingModal}
            onHide={() => {
              setIsShowProcessingModal(false);
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
